// import ApiService from '../../../../shared/services/api-service';
// import commonActions from '../../../../shared/store/common/action-creators';
import departmentActions from '../../department/action-creators';
import optionsActions from '../../options/action-creators';
import addReportCommitTypes from '../commit-types';
// import notificationsActions from '../../notifications/action-creators';

const reportsActionCreators = {
  loadAddReportContainer() {
    return (dispatch) => {
      dispatch(departmentActions.fetchDepartmentForms());
      dispatch(optionsActions.fetchOptions('myOits'));
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: addReportCommitTypes.SET_REPORTS_IS_LOADING,
    };
  },
  unmountAddReportContainer() {
    return {
      type: addReportCommitTypes.RESET_ADD_REPORT_STATE,
    };
  },
};

export default reportsActionCreators;
